<template>
    <div class="image-card">
        <div class="card-background"
            :style="{ 'background-image': 'url(' + item.thumbPath + ')', height: '250px' }">
            <div class="card-content">
                <div class="thumb-section">
                    <router-link :to="{ name: targetPage, query: { postId: item.postId } }">
                        <span v-if="item.thumbPath === null" class="fallback-thumb">
                            <span v-if="item.title !== null && item.title.length > 0">{{ item.title[0] }}</span>
                        </span>
                    </router-link>
                     <price-tag :item="item"></price-tag>
                </div>

                <div class="bottom-info">
                    <!--<div class="category-tags">
                        <div class="category-group">
                            <div class="parent-category agx-theme-bg">{{ item.parentCategory.name }}</div>
                            <div class="child-category">{{ item.category.name }}</div>
                        </div>
                        <price-tag :item="item"></price-tag>
                    </div>-->
                    <!--<post-label :item="item"></post-label>-->
                    <post-tag :item="item"></post-tag>
                    <div class="title-section">
                        <router-link :to="{ name: targetPage, query: { postId: item.postId } }">
                            <span class="card-title">{{ item.title }}</span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import PriceTag from '../PriceTag.vue';
import PostTag from '../PostTag.vue';
import PostLabel from '../PostLabel.vue';

export default {
    components: {
        PostLabel,
        PriceTag,
        PostTag
    },
    filters: {
        cutContent: function (txtMsg) {
            if (txtMsg === null) return;
            var length = 150;
            return txtMsg.length > length ? txtMsg.slice(0, length) + "......" : txtMsg;
        }
    },
    props: ["item", "listingType"],
    computed: {
        targetPage: function () {
            if (this.listingType === 'listing') {
                return "detail";
            }
            return "articleDetail";
        }
    },
    data: function () {
        return {

        }
    },
    mounted: function () {

    }
}
</script>
<style scoped>
.image-card {
    display: block;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}
/* .image-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
} */
.card-background {
    background-position: center;
    background-size: cover;
    position: relative;
    height: 250px;
}
.card-content {
    position: relative;
    height: 100%;
}
.thumb-section {
    text-align: right;
    padding: 5px 0;
}
.fallback-thumb {
    display: inline-block;
    font-weight: bolder;
    text-align: center;
    width: 90px;
    height: 90px;
    line-height: 90px;
    font-size: 48px;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    color: #555;
}
.bottom-info {
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 10px 0;
}
.category-tags {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 10px;
}
.category-group {
    display: inline-flex;
    flex-direction: row;
    border: 1px solid rgba(255,255,255,0.3);
    padding: 6px;
    font-size: 1.1em;
    border-radius: 4px;
    background: rgba(255,255,255,0.1);
}
.parent-category {
    padding: 0 6px;
}
.child-category {
    border-left: 1px solid rgba(255,255,255,0.3);
    padding: 0 10px;
}
.title-section {
    padding: 2px;
    text-align: center;
    background: rgba(255,255,255,0.95);
}
.card-title {
    font-weight: bolder;
    display: block;
    color: #333;
    font-size: 1em;
    padding: 2px;
}
</style>
